module.exports = __webpack_public_path__ + "img/recycle-alpaca.2d1e36ca.svg";